<template>
  <div>
    <el-form ref="formData" :model="formData" :rules="rules" size="mini">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('table_label_customerName') || '客户名称'"
            prop="custName"
          >
            <el-input
              :disabled="disabled"
              v-model="formData.custName"
              :placeholder="$l('tips_pleaseEnter') || '请输入...'"
              maxlength="200"
              show-word-limit
              clearable
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('table_label_business_license') || '统一社会信用代码'"
            prop="businessLicense"
          >
            <el-input
              :disabled="disabled"
              v-model="formData.businessLicense"
              :placeholder="$l('tips_pleaseEnter') || '请输入...'"
              maxlength="50"
              show-word-limit
              clearable
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="$l('table_label_detailedAddress') || '详细地址'"
            prop="custAddress"
          >
            <el-input
              :disabled="disabled"
              v-model="formData.custAddress"
              :placeholder="$l('tips_pleaseEnter') || '请输入...'"
              maxlength="500"
              show-word-limit
              clearable
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <BankTable
          :disabled="disabled"
          :custCode="formData.custCode"
          ref="bankTable"
        />
      </el-row>
    </el-form>

    <el-dialog
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
      append-to-body
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import BankTable from './bank-table/table'
export default {
  mixins: [EditLoading],
  components: { BankTable },
  props: { custCode: String },
  data() {
    return {
      disabled: false,
      cityValid: false,
      backDialogVisible: false,
      bankAccountKindParams: { dictType: 'bankAccountKind' },
      paymentTermsParams: { dictType: 'paymentTerms' },
      formData: {},
      rules: {
        custName: [
          {
            required: true,
            message: this.$l('form_rule_customer_name') || '请输入客户名称',
            trigger: 'blur',
          },
        ],
        customerType: [
          {
            required: true,
            message:
              this.$l('form_label_select_customerType') || '请选择客户类型',
            trigger: 'change',
          },
        ],
        marketRegion: [
          {
            required: true,
            message:
              this.$l('form_label_select_customer_classification') ||
              '请选择客户基本分类',
            trigger: 'change',
          },
        ],
      },
    }
  },
  created() {
    if (this.custCode !== '') {
      this.init()
    }
  },
  methods: {
    async init() {
      await this.loadDetail()
    },
    async loadDetail() {
      if (!this.custCode) return
      return this.$api
        .custInfoDetailApi({ custCode: this.custCode })
        .then((res) => {
          this.formData = res.body
        })
    },
    //客户信息变更
    save() {
      var masterCustomerBankList = this.$refs.bankTable.getTableData()
      this.formData.masterCustomerBankList = masterCustomerBankList
      validate.formValidate([this.$refs.formData], (valid) => {
        if (valid) {
          this.loadingOpen()
          this.$api
            .masterCustomerApplyApi(this.formData)
            .then((res) => {
              this.$api
                .masterCustomerInformationApplyApi({
                  custCode: res.body,
                })
                .then(() => {
                  this.$message.success(
                    this.$l('INDEX.tips_Submitted_successfully') || '提交成功!'
                  )
                  this.$emit('reload')
                  this.close()
                })
                .catch(() => {
                  this.masterCustomerRollbackApply(res.body)
                })
            })
            .catch(() => {
              this.loadingClose()
            })
        }
      })
    },
    masterCustomerRollbackApply(custCode) {
      this.$api
        .masterCustomerRollbackApplyApi({ custCode: custCode })
        .then(() => {
          this.loadingClose()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.loadingClose()
      this.$emit('close')
    },
  },
}
</script>
